module.exports = __webpack_public_path__ + "img/image9.daed87a4.webp";